import React from 'react';

import { LoadingContainer } from './styles';

const Loader = () => {
  return <LoadingContainer />;
};

export default Loader;
